import { Component, Input, signal, OnInit, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './message-message.content.json';

@Component({
    selector: 'message-message',
    templateUrl: './message-message.component.html',
    standalone: false
})
export class MessageMessageComponent implements OnInit {
    @Input()
    public text: string;
    @Input() public showAvatar = signal<boolean>(false);
    @Input() public occurredAt = signal<number>(0);
    public fromClient = signal<boolean>(false);
    public agentOrBot = signal<string>('bot');
    public isMessagePending = signal<boolean>(true);

    private readonly contentService = inject(ApContentService);

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    public determineAvatar(): string {
        return this.agentOrBot() === 'bot' ? 'avatar-bot' : 'avatar-agent';
    }

    public determineAriaLabel(): string {
        if (this.agentOrBot() === 'bot') {
            return this.contentService.get('conversational.chat.message.message.chatbot');
        }

        if (this.agentOrBot() === 'livechat') {
            return this.contentService.get('conversational.chat.message.message.agent');
        }

        if (this.fromClient()) {
            return this.contentService.get('conversational.chat.message.message.own');
        }

        return this.contentService.get('conversational.chat.message.message.other');
    }
}
